import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
//import css from './css.module.less';
import RowBlocks from 'src/components/BlocksInRowDisplay';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Record = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { data } = props;

  return (
    <SectionWrapper
      title={getI18n('voucher.storeVoucherDetail.voucherUsageRecord')}>
      <RowBlocks data={data} />
    </SectionWrapper>
  );
};

export default Record;
